import React from "react";
import PropTypes from 'prop-types';

class MessageStatus extends React.Component {

  render() {
    const {isActive} = this.props;

    if (isActive) {
      return (
          <span className="message-notifications">
              <svg className="message-notifications__icon">
                <use xlinkHref="#icon-comment-solid"/>
              </svg>
          </span>
      )
    }
    return null;
  }
}

export default MessageStatus;

MessageStatus.propTypes = {
  status: PropTypes.string,
  isActive: PropTypes.bool
};
